module.exports = __webpack_public_path__ + "img/sh.9934e582.png";